import { FC } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Link,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { ContainedButton } from "../styled/contained-button";
import { TUserProgramAction } from "../../context/user-program/types";
import { submitHandoutStep } from "../../api/user-program";

type Props = {
  expanded: boolean;
  passed: boolean;
  setCurrentlyOpenStep: React.Dispatch<React.SetStateAction<number>>;
  sectionTitle: string;
  dispatch: React.Dispatch<TUserProgramAction>;
  disabled?: boolean;
  handoutLink: string;
  stepIndex: number;
};

const paragraphs = [
  "Liebe Patientinnen und Patienten,",
  "über die folgende Schaltfläche können Sie ein Informationsblatt herunterladen. Es ermöglicht Ihnen, einige Punkte aus den Videos auch später nachzuschlagen.",
  "Das Informationsblatt fasst die Videos nicht zusammen, das bedeutet, dass Sie die Videos trotzdem anschauen und den Inhalt lernen müssen, um den Test pro Video bestehen zu können.",
];

export const HandoutStep: FC<Props> = ({
  expanded,
  setCurrentlyOpenStep,
  passed,
  sectionTitle,
  dispatch,
  disabled,
  handoutLink,
  stepIndex,
}) => {
  const submit = () => {
    submitHandoutStep({ sectionTitle }).then(() => {
      dispatch({ type: "SUBMIT_HANDOUT_STEP", payload: { sectionTitle } });
    });
  };

  return (
    <Accordion
      disabled={disabled}
      key="step-zero"
      expanded={expanded}
      sx={{ marginTop: "1em" }}
    >
      <AccordionSummary
        onClick={() =>
          setCurrentlyOpenStep((prev) => (prev === stepIndex ? -1 : stepIndex))
        }
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id={`step-zero`}
      >
        {passed && (
          <CheckBoxIcon color="success" sx={{ marginRight: "0.5em" }} />
        )}
        <Typography>Handreichung herunterladen</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          container
          flexDirection="column"
          spacing={3}
          mt={2}
          sx={{ margin: "auto", width: { xs: "90%", md: "60%" } }}
        >
          {paragraphs.map((paragraph) => (
            <Grid key={paragraph} item xs={11} md={12}>
              <Typography variant="body2">{paragraph}</Typography>
            </Grid>
          ))}

          <Grid key="btn" mb={2} item xs={11} md={12} width="100%">
            {/* @TODO - add proper link once you get it */}
            <Link href={handoutLink} target="_blank" onClick={submit}>
              <ContainedButton fullWidth>
                Handreichung herunterladen
                {disabled &&
                  " (Wird freigeschaltet, wenn Sie Tests der vorherigen Module bestanden haben.)"}
              </ContainedButton>
            </Link>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
